import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const DEFAULT_TITLE = 'Don Presupuesto - Alma Quinta';

/**
 * Setea document.title mientras el componente esta montado.
 * Al desmontar (o al cambiar el title), restaura al DEFAULT_TITLE — NO al
 * valor previo capturado. Esto evita que el titulo quede "pegado" de una vista
 * a otra cuando varias montan/desmontan en rapida sucesion, o cuando algun
 * componente setea document.title directo sin cleanup.
 *
 * Uso: useDocumentTitle(`COT-${numero} · ${cliente}`)
 * Si se le pasa null/undefined/'' se deja el DEFAULT (util para paginas neutras).
 */
export function useDocumentTitle(title) {
    useEffect(() => {
        document.title = title || DEFAULT_TITLE;
        return () => { document.title = DEFAULT_TITLE; };
    }, [title]);
}

/**
 * Hook global: fuerza el titulo por defecto en cada cambio de ruta.
 * Se monta UNA vez en App.js para que cualquier navegacion resetee el titulo
 * al default; los componentes que necesiten override lo hacen despues con
 * useDocumentTitle (que corre en su propio efecto luego de este).
 *
 * Sin este hook, si el usuario navega de una cotizacion a una pagina que
 * no llama useDocumentTitle (login, dashboard, no-encontrada), el titulo
 * quedaria pegado como el ultimo que se seteo.
 */
export function useResetTitleOnRouteChange() {
    const location = useLocation();
    useEffect(() => {
        document.title = DEFAULT_TITLE;
    }, [location.pathname]);
}
